import React from 'react';
import { Provider } from 'react-redux';
import getStore from '../../store';

export interface IProviderWrapperProps {
  children: React.ReactChild;
}
const ProviderWrapper = ({ children }: IProviderWrapperProps) => {
  const store = getStore();
  return <Provider store={store}>{children}</Provider>;
};

export default ProviderWrapper;
